function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 155.139 155.139",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    style: {},
    d: "M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z",
    fill: "current",
    "data-original": "#010002",
    className: ""
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.4ad85d90.svg";
export { ForwardRef as ReactComponent };